import { Modal, Button, Collapse, Spin, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CaretRightOutlined, ExclamationCircleOutlined, PlusCircleFilled, DeleteOutlined, EditTwoTone } from "@ant-design/icons";
import styles from "../style/document.module.css";
import { transactionLaneDataHandle } from "../state/actions";
import AddCloserModal from "./AddCloserModal";
import EditTitleCompanyModal from "./EditTitleCompanyModal";
import TitleCompanyDocument from "./TitleCompanyDocument";
import { checkIfDisabled, disabledTransactionText } from "../../Common/commondata/commonData";
import { TitleCompanyDetails } from "./TitleCompanyDetails";
import { formatPhoneNumber } from "../../Common/utils/extraFunctions";
import axios from "axios";
const { Panel } = Collapse;

const TitlecompanyModal = ({ section, isModalOpen, setIsModalOpen, getCoordinateItem, clientRole, delegate }) => {
  const dispatch = useDispatch();
  const bos = section === "BOS";
  const [showTitleCompanyEditModal, setShowTitleCompanyEditModal] = useState({
    source: "TITLE_COMPANY_EDIT",
    open: false,
  });

  const [add, setAdd] = useState({
    open: false,
    section: "",
  });
  const { getTitleCompanySelectedData, getTitleCompanyDataLoading, getTitleCompanyDataError, refreshTitleCompany } = useSelector((state) => state.rtdTransactionLane);
  const [showcompanymodal, setShowcompanymodal] = useState(false);
  const [sendCompanyModal, setSendCompanyModal] = useState(false);
  const [companyModalStep, setCompanyModalStep] = useState({
    step: 0,
    inBuilt: true,
    selectedBy: clientRole === "SELLER" ? "SELLER_AGENT" : "BUYER_AGENT",
    titleCompany: "",
    titleOffice: "",
    titleCloser: "",
    salesRep: "",
  });
  const handleOpenCompanyModal = () => {
    setCompanyModalStep({
      step: 0,
      inBuilt: true,
      selectedBy: clientRole === "SELLER" ? "SELLER_AGENT" : "BUYER_AGENT",
      titleCompany: "",
      titleOffice: "",
      titleCloser: "",
      salesRep: "",
    });
    setShowcompanymodal(true);
  };
  const handleInnerClick = (e) => {
    e.stopPropagation(); // Prevent the click event from propagating to the outer component
    setSendCompanyModal(true);
  };
  const { confirm } = Modal;
  const editTitleCompany = () => {
    setShowTitleCompanyEditModal((prev) => ({ ...prev, open: true }));
  };
  const handleAdd = (value) => {
    setAdd({
      open: !add?.open,
      section: value,
    });
  };
  const delegateSide = delegate && clientRole;
  let unmounted = {
    value: false,
  };
  let source = axios.CancelToken.source();
  useEffect(() => {
    if (getCoordinateItem?.offerId) {
      dispatch(transactionLaneDataHandle.getIndividualTransaction({ offerId: getCoordinateItem.offerId, unmounted, source, delegateSide, delegateOwnerId: (delegateSide || bos) && getCoordinateItem?.currentAgentId?._id, ...(bos && { screenType: "BOS" }) }));
    }
  }, []);

  useEffect(() => {
    if (getCoordinateItem?.offerId) {
      dispatch(transactionLaneDataHandle.getTitleCompanyData({ offerId: getCoordinateItem.offerId, source, unmounted, delegateSide, delegateOwnerId: (delegateSide || bos) && getCoordinateItem?.currentAgentId?._id, screenType: bos && "BOS" }));
    }
    return () => {
      unmounted.value = true;
      source.cancel("Cancelling in cleanup");
    };
  }, [refreshTitleCompany]);

  const handeldeleteTitleCompanydata = (val) => {
    confirm({
      title: `Are you sure, you want to clear ${val === "affiliate" ? "all data from Other" : "Title Company"} ?`,
      content: val === "affiliate" ? "" : "Note: Clearing the title company will clear title company information from the Title Order and Closing Instructions form. If Closing Instructions has been signed and not sent to other broker, signatures will be reset. If Closing Instructions has been signed and has been sent to other broker the title company won't be cleared in those document.",
      okText: "Yes",
      cancelText: "No",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        if (val === "affiliate") {
          dispatch(transactionLaneDataHandle.deleteTitleCompanyData({ offerId: getCoordinateItem?.offerId, delegateSide, clearAffliates: true }));
        } else {
          dispatch(transactionLaneDataHandle.deleteTitleCompanyData({ offerId: getCoordinateItem?.offerId, delegateSide, clearAffliates: false }));
        }
      },
      onCancel() {},
    });
  };
  const handleEditAffiliate = (item) => {
    setAdd({
      open: !add?.open,
      section: "EDIT_AFFILIATE",
      affiliateData: item,
    });
  };

  const onFinish = (values) => {
    const processObj = {
      ...(values?.name ? { name: values?.name } : {}),
      ...(values?.email ? { email: values?.email } : {}),
      ...(values?.phoneNumber ? { phoneNumber: values?.phoneNumber } : {}),
    };
    const affiliateObj = {
      ...(values?.name ? { name: values?.name } : {}),
      ...(values?.email ? { email: values?.email } : {}),
      ...(values?.phoneNumber ? { phoneNumber: values?.phoneNumber } : {}),
      ...(values?.role ? { role: values?.role } : {}),
    };
    const payload = {
      selectedBy: clientRole === "BUYER" ? "BUYER_AGENT" : "SELLER_AGENT",
      offerId: getCoordinateItem?.offerId || null,
    };
    let processorArr = [...getTitleCompanySelectedData?.processors, processObj];
    let affiliateArr = getTitleCompanySelectedData?.affiliateDetails?.affiliates ? [...getTitleCompanySelectedData?.affiliateDetails?.affiliates, affiliateObj] : [affiliateObj];
    if (add?.section === "Processor") {
      dispatch(transactionLaneDataHandle.addTitleOffice({ payload, delegateSide, delegateOwnerId: (delegateSide || bos) && getCoordinateItem?.currentAgentId?._id, screenType: bos && "BOS", processorArr, processObj }));
    } else if (add?.section === "EDIT_AFFILIATE" && add?.affiliateData?._id) {
      dispatch(transactionLaneDataHandle?.editTitleCompanyDataInOffer({ payload: { ...payload, affiliates: [affiliateObj], inBuilt: getTitleCompanySelectedData?.inBuilt }, offerId: getCoordinateItem?.offerId, affiliateObj, source: "EDIT_AFFILIATE", updatingAffiliateId: add?.affiliateData?._id }));
    } else {
      dispatch(transactionLaneDataHandle.addTitleOffice({ payload, delegateSide, delegateOwnerId: (delegateSide || bos) && getCoordinateItem?.currentAgentId?._id, screenType: bos && "BOS", affiliateArr, affiliateObj }));
    }
    handleAdd("");
  };

  const handleOpen = () => {
    handleOpenCompanyModal();
  };
  const handleAddProcessor = () => {
    handleAdd("Processor");
  };

  const handleAddAffilatesModalOpen = () => {
    handleAdd("Affiliate");
  };

  const handleDelete = (ele = {}, source) => {
    Modal.confirm({
      title: `Are you sure you want to delete ${ele?.name}?`,
      okText: "Yes",
      cancelText: "No",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        const payload = {
          selectedBy: clientRole === "BUYER" ? "BUYER_AGENT" : "SELLER_AGENT",
          offerId: getCoordinateItem?.offerId || null,
          inBuilt: true,
        };
        if (source === "Affiliate") {
          const affiliates = getTitleCompanySelectedData?.affiliateDetails?.affiliates || [];
          const updatedAffiliates = affiliates.filter((el) => el?._id !== ele?._id);

          dispatch(
            transactionLaneDataHandle.addTitleOffice({
              payload,
              delegateSide,
              delegateOwnerId: (delegateSide || bos) && getCoordinateItem?.currentAgentId?._id,
              screenType: bos && "BOS",
              affiliateArr: updatedAffiliates,
              category: "deleteAffiliate",
              data: ele,
            })
          );
        } else {
          const processors = getTitleCompanySelectedData?.processors || [];
          const updatedProcessors = processors.filter((el) => el?._id !== ele?._id);

          dispatch(
            transactionLaneDataHandle.addTitleOffice({
              payload,
              delegateSide,
              delegateOwnerId: (delegateSide || bos) && getCoordinateItem?.currentAgentId?._id,
              screenType: bos && "BOS",
              processorArr: updatedProcessors,
              category: "deleteProcessor",
              data: ele,
            })
          );
        }
      },
      onCancel() {},
    });
  };

  const checkForDisable = checkIfDisabled({ openFor: clientRole, actualPropertyStatus: getCoordinateItem?.actualPropertyStatus, buyingStatus: getCoordinateItem?.actualOfferStatus, offerStatus: getCoordinateItem?.status });

  return (
    <>
      {showcompanymodal && <TitleCompanyDetails section={section} setShowcompanymodal={setShowcompanymodal} showcompanymodal={showcompanymodal} selectedStatus={clientRole} companyModalStep={companyModalStep} setCompanyModalStep={setCompanyModalStep} item={getCoordinateItem} />}

      {sendCompanyModal && <TitleCompanyDocument clientRole={clientRole} getCoordinateItem={getCoordinateItem} setSendCompanyModal={setSendCompanyModal} section={section} />}

      {add?.open && <AddCloserModal add={add} setAdd={setAdd} handleAdd={handleAdd} onFinish={onFinish} companyModalStep={companyModalStep} setCompanyModalStep={setCompanyModalStep} selectedStatus={clientRole} getCoordinateItem={getCoordinateItem} />}

      {showTitleCompanyEditModal.open && getTitleCompanySelectedData?.titleCompanyName && (
        <EditTitleCompanyModal setShowTitleCompanyEditModal={setShowTitleCompanyEditModal} showTitleCompanyEditModal={showTitleCompanyEditModal} selectedData={getCoordinateItem} companyModalStep={companyModalStep} setCompanyModalStep={setCompanyModalStep} getTitleCompanySelectedData={getTitleCompanySelectedData} offerId={getCoordinateItem?.offerId} propertyId={getCoordinateItem?.propertyId} source={"INSIDE_RTD"} />
      )}

      <Modal width={800} title={<span style={{ display: "flex", justifyContent: "center", color: "#178DFA", fontWeight: "bold", fontSize: "22px" }}>Title Company & Affiliates</span>} visible={isModalOpen?.titleCompany} onCancel={() => setIsModalOpen({ ...isModalOpen, titleCompany: false })} footer={false}>
        <div style={{ minHeight: "400px", height: "60vh", overflow: "auto", paddingRight: "10px" }}>
          <Collapse
            ghost
            defaultActiveKey={["2"]}
            expandIcon={({ isActive }) => (
              <div style={{ verticalAlign: "middle" }}>
                <CaretRightOutlined rotate={isActive ? 90 : 0} style={{ fontSize: "1.3rem" }} />
              </div>
            )}
          >
            <Panel
              style={{ marginTop: "10px", border: "1px solid #cccccc", borderRadius: "10px" }}
              key="2"
              expandIcon={({ isActive }) => (
                <div style={{ verticalAlign: "middle" }}>
                  <CaretRightOutlined rotate={isActive ? 90 : 0} style={{ fontSize: "1.3rem" }} />
                </div>
              )}
              header={
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", cursor: "default" }} onClick={(e) => e.stopPropagation()}>
                  <span
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      marginLeft: ".3rem",
                      color: "#096dd9",
                    }}
                  >
                    Title Company
                  </span>
                  <div style={{ display: "flex", gap: "10px" }}>
                    {getTitleCompanySelectedData?.titleCompanyName && (
                      <span>
                        <Tooltip title={checkForDisable?.disabled || (clientRole === "SELLER" && getTitleCompanySelectedData?.selectedBy !== "SELLER_AGENT") || (clientRole === "BUYER" && getTitleCompanySelectedData?.selectedBy !== "BUYER_AGENT") ? "" : "Edit Title Company"}>
                          <EditTwoTone
                            {...(checkForDisable?.disabled ? { onClick: disabledTransactionText } : (clientRole === "SELLER" && getTitleCompanySelectedData?.selectedBy === "SELLER_AGENT") || (clientRole === "BUYER" && getTitleCompanySelectedData?.selectedBy === "BUYER_AGENT") ? { onClick: editTitleCompany } : { onClick: undefined })}
                            style={
                              (clientRole === "SELLER" && getTitleCompanySelectedData?.selectedBy === "SELLER_AGENT") || (clientRole === "BUYER" && getTitleCompanySelectedData?.selectedBy === "BUYER_AGENT")
                                ? {}
                                : {
                                    // pointerEvents: "none",
                                    cursor: "not-allowed",
                                    color: "grey",
                                    opacity: 0.5,
                                  }
                            }
                          />
                        </Tooltip>
                      </span>
                    )}
                    {!getTitleCompanyDataLoading &&
                      <span>
                        <Tooltip title="Add Title Company">
                          <PlusCircleFilled {...(checkForDisable?.disabled ? { onClick: disabledTransactionText } : { onClick: handleOpen })} style={{ fontSize: "25px", color: "#085190" }} />
                        </Tooltip>
                      </span>
                    }
                  </div>
                </div>
              }
              headerStyle={{ outline: "auto" }}
            >
              <div
                style={{
                  minHeight: "200px",

                  overflowY: "auto",
                }}
              >
                {getTitleCompanyDataLoading ? (
                  <div style={{ minHeight: "200px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Spin size="large" />
                  </div>
                ) : getTitleCompanyDataError ? (
                  ""
                ) : (
                  getTitleCompanySelectedData &&
                  getTitleCompanySelectedData?.titleCompanyName && (
                    <div style={{ padding: "6px 18px 18px", display: "flex", flexDirection: "column", color: "gray" }}>
                      <div
                        style={{
                          margin: "auto",
                        }}
                      >
                        {getTitleCompanySelectedData?.titleCompanyLogo && (
                          <img
                            src={getTitleCompanySelectedData?.titleCompanyLogo}
                            style={{
                              height: "60px",
                              width: "80px",
                              objectFit: "contain",
                              maxWidth: "100%",
                            }}
                            alt=""
                          />
                        )}
                      </div>
                      <div className={styles.titleCompanyDetailCont}>
                        <table className={styles.titleCompanyDetailTable}>
                          {getTitleCompanySelectedData?.titleCompanyName && (
                            <tr>
                              <td className={styles.label}>Company</td>
                              <td className={styles.value}>{getTitleCompanySelectedData?.titleCompanyName}</td>
                            </tr>
                          )}
                          {getTitleCompanySelectedData?.titleCompanyEmail && (
                            <tr>
                              <td className={styles.label}>Company Email</td>
                              <td className={styles.value}>{getTitleCompanySelectedData?.titleCompanyEmail}</td>
                            </tr>
                          )}
                          {getTitleCompanySelectedData?.titleCompanyPhoneNumber && (
                            <tr>
                              <td className={styles.label}>Company Ph.</td>
                              <td className={styles.value}>{formatPhoneNumber(getTitleCompanySelectedData?.titleCompanyPhoneNumber)}</td>
                            </tr>
                          )}
                          {getTitleCompanySelectedData?.titleOfficeName && (
                            <tr>
                              <td className={styles.label}>Office</td>
                              <td className={styles.value}>{getTitleCompanySelectedData?.titleOfficeName}</td>
                            </tr>
                          )}
                          {getTitleCompanySelectedData?.titleOfficeAddress && (
                            <tr>
                              <td className={styles.label}>Office Address</td>
                              <td className={styles.value}>{getTitleCompanySelectedData?.titleOfficeAddress}</td>
                            </tr>
                          )}
                          {getTitleCompanySelectedData?.titleOfficeEmail && (
                            <tr>
                              <td className={styles.label}>Office Email</td>
                              <td className={styles.value}>{getTitleCompanySelectedData?.titleOfficeEmail}</td>
                            </tr>
                          )}
                          {getTitleCompanySelectedData?.titleOfficePhoneNo && (
                            <tr>
                              <td className={styles.label}>Office Ph.</td>
                              <td className={styles.value}>{formatPhoneNumber(getTitleCompanySelectedData?.titleOfficePhoneNo)}</td>
                            </tr>
                          )}
                          {getTitleCompanySelectedData?.titleOfficeFaxNo && (
                            <tr>
                              <td className={styles.label}>Office Fax No.</td>
                              <td className={styles.value}>{formatPhoneNumber(getTitleCompanySelectedData?.titleOfficeFaxNo)}</td>
                            </tr>
                          )}

                          {getTitleCompanySelectedData?.salesRepName && (
                            <tr>
                              <td className={styles.label}>Sales Rep</td>
                              <td className={styles.value}>{getTitleCompanySelectedData?.salesRepName ? getTitleCompanySelectedData?.salesRepName : ""}</td>
                            </tr>
                          )}
                          {getTitleCompanySelectedData?.salesRepEmail && (
                            <tr>
                              <td className={styles.label}>Sales Rep Email</td>
                              <td className={styles.value}>{getTitleCompanySelectedData?.salesRepEmail ? getTitleCompanySelectedData?.salesRepEmail : ""}</td>
                            </tr>
                          )}
                          {getTitleCompanySelectedData?.salesRepPhone && (
                            <tr>
                              <td className={styles.label}>Sales Rep Ph.</td>
                              <td className={styles.value}>{formatPhoneNumber(getTitleCompanySelectedData?.salesRepPhone)}</td>
                            </tr>
                          )}
                          {getTitleCompanySelectedData?.titleCloserName && (
                            <tr>
                              <td className={styles.label}>Title Closer</td>
                              <td className={styles.value}>{getTitleCompanySelectedData?.titleCloserName}</td>
                            </tr>
                          )}
                          {getTitleCompanySelectedData?.titleCloserEmail && (
                            <tr>
                              <td className={styles.label}>Closer Email</td>
                              <td className={styles.value}>{getTitleCompanySelectedData?.titleCloserEmail}</td>
                            </tr>
                          )}
                          {getTitleCompanySelectedData?.titleCloserPhone && (
                            <tr>
                              <td className={styles.label}>Closer Ph.</td>
                              <td className={styles.value}>{formatPhoneNumber(getTitleCompanySelectedData?.titleCloserPhone)}</td>
                            </tr>
                          )}
                        </table>
                        <div>
                          <span style={{ color: "#2875be", fontWeight: "bold", fontSize: "20px", margin: "auto" }}>
                            Processors
                            <PlusCircleFilled
                              style={{
                                fontSize: "18px",
                                color: getTitleCompanySelectedData && getTitleCompanySelectedData.titleCompanyName && companyModalStep.selectedBy !== getTitleCompanySelectedData?.selectedBy ? "#c2c2c2" : "#085190",
                                margin: "10px 0 0 5px",
                                cursor: getTitleCompanySelectedData && getTitleCompanySelectedData.titleCompanyName && companyModalStep.selectedBy !== getTitleCompanySelectedData?.selectedBy ? "not-allowed" : "pointer",
                              }}
                              onClick={getTitleCompanySelectedData && getTitleCompanySelectedData.titleCompanyName && companyModalStep.selectedBy !== getTitleCompanySelectedData?.selectedBy ? undefined : handleAddProcessor}
                            />
                          </span>
                          {getTitleCompanySelectedData?.processors?.length > 0 && (
                            <div>
                              {getTitleCompanySelectedData?.processors?.map((el, ind) => {
                                return (
                                  <div style={{ display: "flex", gap: "5px", padding: "6px 0", borderBottom: ind !== getTitleCompanySelectedData?.processors?.length - 1 ? "1px solid #a3a3a3" : "" }}>
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "80px auto",
                                        rowGap: "6px",
                                        width: "100%",
                                      }}
                                    >
                                      <span style={{ fontWeight: "600", color: "#2976be" }}>Name</span>
                                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <span>{el?.name}</span>
                                        <span>
                                          <DeleteOutlined
                                            style={{
                                              color: getTitleCompanySelectedData && getTitleCompanySelectedData.titleCompanyName && companyModalStep.selectedBy !== getTitleCompanySelectedData?.selectedBy ? "#c2c2c2" : "#2976be",
                                              fontSize: "15px",
                                              cursor: getTitleCompanySelectedData && getTitleCompanySelectedData.titleCompanyName && companyModalStep.selectedBy !== getTitleCompanySelectedData?.selectedBy ? "not-allowed" : "pointer",
                                            }}
                                            onClick={getTitleCompanySelectedData && getTitleCompanySelectedData.titleCompanyName && companyModalStep.selectedBy !== getTitleCompanySelectedData?.selectedBy ? undefined : () => handleDelete(el, "Processor")}
                                          />
                                        </span>
                                      </div>

                                      <span style={{ fontWeight: "600", color: "#2976be" }}>Email</span>
                                      <span
                                        style={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          display: "block",
                                        }}
                                      >
                                        {el?.email}
                                      </span>

                                      {el?.phoneNumber && (
                                        <>
                                          <span style={{ fontWeight: "600", color: "#2976be" }}>Phone</span>
                                          <span>{formatPhoneNumber(el?.phoneNumber)}</span>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                      <div style={{ textAlign: "center", maxWidth: "100%", marginTop: "10px", borderRadius: "8px" }}>
                        <Button type="primary" disabled={(clientRole === "SELLER" && getTitleCompanySelectedData?.selectedBy === "SELLER_AGENT") || (clientRole === "BUYER" && getTitleCompanySelectedData?.selectedBy === "BUYER_AGENT") ? false : true} {...(checkForDisable?.disabled ? { onClick: disabledTransactionText } : { onClick: handeldeleteTitleCompanydata })}>
                          Clear
                        </Button>
                        <Button type="primary" style={{ marginLeft: "5px" }} disabled={!getTitleCompanySelectedData?.titleCloserEmail && !getTitleCompanySelectedData?.titleOfficeEmail && !getTitleCompanySelectedData?.salesRepEmail} onClick={handleInnerClick}>
                          Send
                        </Button>
                      </div>
                    </div>
                  )
                )}
              </div>
            </Panel>
          </Collapse>

          <Collapse
            ghost
            defaultActiveKey={["3"]}
            expandIcon={({ isActive }) => (
              <div style={{ verticalAlign: "middle" }}>
                <CaretRightOutlined rotate={isActive ? 90 : 0} style={{ fontSize: "1.3rem" }} />
              </div>
            )}
          >
            <Panel
              style={{ marginTop: "10px", border: "1px solid #cccccc", borderRadius: "10px" }}
              key="3"
              expandIcon={({ isActive }) => (
                <div style={{ verticalAlign: "middle" }}>
                  <CaretRightOutlined rotate={isActive ? 90 : 0} style={{ fontSize: "1.3rem" }} />
                </div>
              )}
              header={
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", cursor: "default" }} onClick={(e) => e.stopPropagation()}>
                  <span
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      marginLeft: ".3rem",
                      color: "#096dd9",
                    }}
                  >
                    Other
                  </span>
                  {!getTitleCompanyDataLoading && (
                      <span>
                        <PlusCircleFilled {...(checkForDisable?.disabled ? { onClick: disabledTransactionText } : { onClick: handleAddAffilatesModalOpen })} style={{ fontSize: "25px", color: "#085190" }} />
                      </span>
                    )}
                </div>
              }
            >
              <div style={{ padding: "6px 18px 18px", display: "flex", flexDirection: "column", color: "gray" }}>
                {getTitleCompanyDataLoading ? (
                  <div style={{ minHeight: "200px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Spin size="large" />
                  </div>
                ) : getTitleCompanyDataError ? (
                  ""
                ) : (
                  getTitleCompanySelectedData &&
                  getTitleCompanySelectedData?.affiliateDetails &&
                  getTitleCompanySelectedData?.affiliateDetails?.affiliates?.length > 0 && (
                    <>
                      <div>
                        {getTitleCompanySelectedData?.affiliateDetails && getTitleCompanySelectedData?.affiliateDetails?.affiliates?.length > 0 && (
                          <div>
                            {getTitleCompanySelectedData?.affiliateDetails?.affiliates?.map((el, ind) => {
                              return (
                                <div style={{ display: "flex", gap: "5px", padding: "5px 0", color: "#808080", fontWeight: "500", borderBottom: ind !== getTitleCompanySelectedData?.affiliateDetails?.affiliates?.length - 1 ? "1px solid #a3a3a3" : "" }}>
                                  <div
                                    style={{
                                      display: "grid",
                                      gridTemplateColumns: "80px auto",
                                      rowGap: "6px",
                                      width: "100%",
                                    }}
                                  >
                                    <span style={{ fontWeight: "600", color: "#2976be" }}>Name</span>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                      <span>{el?.name}</span>
                                      {getTitleCompanySelectedData?.affiliateDetails?.affiliates?.length > 0 && (
                                        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                          <Tooltip title={checkForDisable?.disabled || (clientRole === "SELLER" && getTitleCompanySelectedData?.affiliateDetails?.selectedBy !== "SELLER_AGENT") || (clientRole === "BUYER" && getTitleCompanySelectedData?.affiliateDetails?.selectedBy !== "BUYER_AGENT") ? "" : "Edit Affiliate"}>
                                            <EditTwoTone
                                              {...(checkForDisable?.disabled ? { onClick: disabledTransactionText } : (clientRole === "SELLER" && getTitleCompanySelectedData?.affiliateDetails?.selectedBy === "SELLER_AGENT") || (clientRole === "BUYER" && getTitleCompanySelectedData?.affiliateDetails?.selectedBy === "BUYER_AGENT") ? { onClick: () => handleEditAffiliate(el) } : { onClick: undefined })}
                                              style={
                                                (clientRole === "SELLER" && getTitleCompanySelectedData?.affiliateDetails?.selectedBy === "SELLER_AGENT") || (clientRole === "BUYER" && getTitleCompanySelectedData?.affiliateDetails?.selectedBy === "BUYER_AGENT")
                                                  ? {}
                                                  : {
                                                      // pointerEvents: "none",
                                                      cursor: "not-allowed",
                                                      color: "grey",
                                                      opacity: 0.5,
                                                    }
                                              }
                                            />
                                          </Tooltip>
                                          <Tooltip title={getTitleCompanySelectedData?.affiliateDetails?.selectedBy !== companyModalStep?.selectedBy ? "" : "Delete Affiliate"}>
                                            <DeleteOutlined
                                              style={{
                                                color: getTitleCompanySelectedData && getTitleCompanySelectedData?.affiliateDetails && getTitleCompanySelectedData?.affiliateDetails?.selectedBy !== companyModalStep.selectedBy ? "#d9d9d9" : "#2976be",
                                                fontSize: "15px",
                                                cursor: getTitleCompanySelectedData && getTitleCompanySelectedData?.affiliateDetails && getTitleCompanySelectedData?.affiliateDetails?.selectedBy !== companyModalStep.selectedBy ? "not-allowed" : "pointer",
                                              }}
                                              onClick={getTitleCompanySelectedData && getTitleCompanySelectedData?.affiliateDetails && getTitleCompanySelectedData?.affiliateDetails?.selectedBy !== companyModalStep.selectedBy ? undefined : () => handleDelete(el, "Affiliate")}
                                            />
                                          </Tooltip>
                                        </div>
                                      )}
                                    </div>

                                    <span style={{ fontWeight: "600", color: "#2976be" }}>Email</span>
                                    <span
                                      style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "block",
                                      }}
                                    >
                                      {el?.email}
                                    </span>

                                    {el?.role && (
                                      <>
                                        <span style={{ fontWeight: "600", color: "#2976be" }}>Role/Title</span>
                                        <span>{el?.role}</span>
                                      </>
                                    )}

                                    {el?.phoneNumber && (
                                      <>
                                        <span style={{ fontWeight: "600", color: "#2976be" }}>Phone</span>
                                        <span>{formatPhoneNumber(el?.phoneNumber)}</span>
                                      </>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>

                      <div style={{ textAlign: "center", maxWidth: "100%", margin: "10px 0", borderRadius: "8px" }}>
                        <Button type="primary" disabled={(clientRole === "SELLER" && getTitleCompanySelectedData?.affiliateDetails?.selectedBy === "SELLER_AGENT") || (clientRole === "BUYER" && getTitleCompanySelectedData?.affiliateDetails?.selectedBy === "BUYER_AGENT") ? false : true} {...(checkForDisable?.disabled ? { onClick: disabledTransactionText } : { onClick: () => handeldeleteTitleCompanydata("affiliate") })}>
                          Clear
                        </Button>
                        <Button type="primary" style={{ marginLeft: "5px" }} disabled={!getTitleCompanySelectedData?.affiliateDetails && !getTitleCompanySelectedData?.affiliateDetails?.affiliates?.length} onClick={handleInnerClick}>
                          Send
                        </Button>
                      </div>
                    </>
                  )
                )}
              </div>
            </Panel>
          </Collapse>
        </div>
      </Modal>
    </>
  );
};

export default TitlecompanyModal;
